export const companyFileName = (
  file: any,
  subdomain: string,
  fileType: string
) => {
  const type = file[0].file.type.split('/');
  return `${subdomain}_${fileType}.${type[1]}`;
};
